import React from 'react';
import Typewriter from './Typewriter';

const Hero = () => {
    const animationEnabled = true;
    const loopAnimation = false;

    return (
        <div id="hero" className="relative h-screen bg-[#e3daec]">
            <div className="h-full flex flex-col justify-center items-center">
                <div className="absolute inset-0 bg-[#e3daec] px-4 sm:px-8 md:px-12 lg:px-18">
                    <div className='parent flex flex-col items-center justify-start h-screen pt-16 sm:pt-20 md:pt-24 lg:pt-28 pb-4'>
                        <div className="hero__content flex items-center justify-center w-full max-w-7xl h-2/3 md:h-full pt-8 sm:pt-12 md:pt-16 lg:pt-24">
                            <h1 className="hero__title font-cormorant-light text-5xl sm:text-6xl md:text-7xl lg:text-9xl xl:text-[157px] text-center">
                                <Typewriter
                                    text="Hi, I'm Ashima"
                                    delay={120}
                                    isEnabled={animationEnabled}
                                    shouldLoop={loopAnimation}
                                />
                            </h1>
                        </div>

                        <div className="hero_footer flex flex-row lg:flex-row items-center justify-center w-full max-w-7xl lg:gap-0 lg:h-2/3">
                            <div className="hero_footer_left w-2/3 lg:w-1/2 flex items-end justify-center lg:justify-start h-auto lg:h-full">
                                <span className='font-nunito-sans text-base sm:text-base font-bold w-full text-left lg:w-1/2 lg:text-left'>
                                    Your trusted partner in personal and professional growth
                                </span>
                            </div>
                            <div className="hero_footer_right flex flex-col sm:flex-row items-end justify-end lg:justify-end w-1/3 lg:w-1/2 h-auto lg:h-full space-y-2 sm:space-y-0 sm:space-x-2 lg:space-x-4">

                                <a href="#about" className="animate-bounce">
                                    <img src="/down_arrow.png" alt="down arrow icon" className='w-12 h-12 sm:w-10 sm:h-10 lg:w-[50px] lg:h-[50px]' />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;